import {
  Button
} from "@art-of-hospitality-solutions-llc/ui-kit/components/button";
import React, { useState } from "react";

const EditTagModal = ({
  onSave,
  onClose,
  editInfo,
  setEditInfo
}) => {

  return (
    <div
      className="fixed inset-0 bg-gray-900/50 flex justify-center items-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-lg p-6 w-full max-w-xl relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 font-bold text-2xl"
        >
          &times;
        </button>
        <div className="text-center">
          <h2 className="text-xl font-bold mb-4">Edit Tag</h2>
          <p className="text-lg mb-4">
            Enter a new Tag name
          </p>
          <div className="mb-4">
            <input
              type="text"
              value={editInfo.name}
              onChange={(e) => setEditInfo({ ...editInfo, name: e.target.value })}
              className="w-full p-2 border border-gray-300 rounded"
              placeholder="New Tag Name..."
              autoFocus
            />
          </div>
          <div className="flex justify-center space-x-4">
            <Button
              onClick={onSave}
              disabled={!editInfo.name}
              className={`${editInfo.name
                ? ""
                : "bg-gray-300 text-gray-500 cursor-not-allowed"
                } px-4 py-2 rounded`}
            >
              Save
            </Button>
            <Button
              onClick={onClose}
              className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400"
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditTagModal;
